import { render, staticRenderFns } from "./checkout-confirmation.vue?vue&type=template&id=0c643591&scoped=true&"
import script from "./checkout-confirmation.vue?vue&type=script&lang=js&"
export * from "./checkout-confirmation.vue?vue&type=script&lang=js&"
import style0 from "./checkout-confirmation.vue?vue&type=style&index=0&id=0c643591&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c643591",
  null
  
)

export default component.exports